module.exports = __webpack_public_path__ + "img/pic__photo_02@2x.94d2f0dd.png";